import {Component, Input, OnInit} from '@angular/core';
import {PreorderType} from '../../../smoothr-web-app-core/enums/PreorderType';
import moment from 'moment';
import {TranslateService} from '@ngx-translate/core';
import {RepositoryService} from '../../../smoothr-web-app-core/services/repository/repository.service';
import {AlertController, ModalController} from '@ionic/angular';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ActivatedRoute, Router} from '@angular/router';
import RepositoryInterface from '../../../smoothr-web-app-core/directives/repository-directive';
import {OrderListAction} from '../../enums/OrderListAction';
import {AppComponent} from '../../app.component';
import {ModalInfoComponent} from '../modal-info/modal-info.component';
import {CheckoutModalComponent} from '../checkout-modal/checkout-modal.component';
import {OrderUtils} from '../../../smoothr-web-app-core/utils/order-utils';
import Article from '../../../smoothr-web-app-core/models/Article';
import ArticleOption from '../../../smoothr-web-app-core/models/ArticleOption';
import {MenuPage} from '../../pages/menu/menu.page';
import Order from '../../../smoothr-web-app-core/models/Order';
import {PromoCodeType} from '../../../smoothr-web-app-core/models/PromoCodeType';
import {
	numberToCurrency,
	sleep
} from '../../../smoothr-web-app-core/utils/utils';
import {AnalyticsService} from '../../../smoothr-web-app-core/services/analytics/analytics.service';
import {NoteArticleModalComponent} from '../note-article-modal/note-article-modal.component';
import {Api} from 'src/smoothr-web-app-core/api/api';
import {
	PaymentModalComponent,
	PaymentModalResult
} from 'src/smoothr-web-app-core/components/payment-modal/payment-modal.component';
import {NavigationService} from 'src/app/services/navigation.service';
import {Coupon} from 'src/smoothr-web-app-core/models/Coupon';
@Component({
	selector: 'app-order-content',
	templateUrl: './order-content.component.html',
	styleUrls: ['order-content.component.scss']
})
export class OrderContentComponent
	extends RepositoryInterface
	implements OnInit
{
	moment = moment;

	isValid = false;
	loading = false;

	ou = OrderUtils;
	pt = PreorderType;
	differenceToMvo: number;
	@Input()
	fromMenu = false;
	promoError: string;
	tip = 0;

	numberToCurrency = numberToCurrency;

	constructor(
		private translate: TranslateService,
		protected repository: RepositoryService,
		private modalCtrl: ModalController,
		private snackbarCtrl: MatSnackBar,
		private router: Router,
		private route: ActivatedRoute,
		private alertCtrl: AlertController,
		private analytics: AnalyticsService,
		private navService: NavigationService
	) {
		super(repository);
		this.validate();
		console.log('ngOnInit');
	}

	get hasArticles(): boolean {
		return (this.order?.orderedArticles?.length ?? 0) > 0;
	}

	ngOnInit() {
		super.ngOnInit();
		this.analytics.openOrderContent();
		this.route.queryParams.subscribe(params => {
			if (this.router.url.includes('payment/fail') && params['order']) {
				console.log('YES BOY');
				this.reopenPaymentMethod(params['order']);
			}
		});
	}

	onVenue() {
		super.onVenue();
		this.validate();
	}

	onOrder() {
		super.onOrder();
		if (
			this.order &&
			this.order.orderedArticles &&
			this.order.orderedArticles.length > 0
		) {
			this.analytics.orderHasProducts();
		}
		this.validate();
	}

	async onAction(index: number, event: OrderListAction) {
		switch (event) {
			case OrderListAction.add:
				this.order.orderedArticles[index].quantity += 1;
				break;
			case OrderListAction.delete:
				// logic for deleting coupon while clicking on article coupon
				// if (
				// 	this.order.orderedArticles[index]?.isPromo &&
				// 	this.order.coupon.length
				// ) {
				// 	const coupon = this.order.coupon.find(
				// 		coupon =>
				// 			coupon?.value?.includes(
				// 				this.order.orderedArticles[index]?.article?._id
				// 			)
				// 	);
				// 	if (!coupon) {
				// 		return;
				// 	}
				// 	this.deleteCoupon(coupon);
				// }
				if (
					OrderUtils.isBogoOrFreeArticlePromo(this.order) &&
					this.order.promoCode.type === PromoCodeType.BOGO
				) {
					const bogoArticleIndex = this.order.orderedArticles.findIndex(
						ag => ag.isPromo
					);
					const bogoArticle = this.order.orderedArticles[bogoArticleIndex];
					const matchingBogoArticleIndices = this.order.orderedArticles
						.map((ag, agIndex) => {
							return ag.article._id === bogoArticle.article._id &&
								!ag.isPromo &&
								OrderUtils.bogoPrice(
									ag,
									this.order.type,
									this.order.preorder.type
								) ===
									OrderUtils.bogoPrice(
										bogoArticle,
										this.order.type,
										this.order.preorder.type
									)
								? agIndex
								: -1;
						})
						.filter(agIndex => agIndex !== -1);
					if (
						matchingBogoArticleIndices.find(
							bogoIndex => bogoIndex === index
						) !== undefined
					) {
						// article that should be removed is a possible parent of promoCode article
						if (matchingBogoArticleIndices.length === 1) {
							// only that article is possible parent of promoCode. If this article is removed the PromoCode and PromoArticle
							// should also be removed. Ask user.
							const bogoAlert = await this.alertCtrl.create({
								header: this.translate.instant('remove_bogo_alert.header'),
								message: this.translate.instant('remove_bogo_alert.message'),
								buttons: [
									{
										text: this.translate.instant(
											'remove_bogo_alert.button_remove'
										),
										handler: () => {
											this.order.orderedArticles[bogoArticleIndex].isPromo =
												false;
											this.order.promoCode = null;
											this.order.orderedArticles.splice(index, 1);
											bogoAlert.dismiss();
										}
									},
									{
										text: this.translate.instant(
											'remove_bogo_alert.button_keep'
										),
										handler: () => {
											bogoAlert.dismiss();
										}
									}
								]
							});
							await bogoAlert.present();
							await bogoAlert.onDidDismiss();
							break;
						}
					}
				}
				this.order.orderedArticles.splice(index, 1);

				break;
			case OrderListAction.note:
				this.noteArticle(index);
				break;
			case OrderListAction.edit:
				const modal = await this.modalCtrl.create({
					cssClass: AppComponent.largeScreen
						? 'item-modal large-modal'
						: 'item-modal',
					component: ModalInfoComponent,
					componentProps: {
						// copy article group
						articleGroup: JSON.parse(
							JSON.stringify(this.order.orderedArticles[index])
						),
						recommend: false
					},
					showBackdrop: true,
					backdropDismiss: true
				});
				await modal.present();
				const response = await modal.onDidDismiss();
				if (response.data && response.data.articleGroup) {
					const promoAgIndex = this.order.orderedArticles.findIndex(
						oa => oa.isPromo
					);
					if (
						OrderUtils.isBogoOrFreeArticlePromo(this.order) &&
						this.order.promoCode.type === PromoCodeType.BOGO &&
						this.order.orderedArticles[index].article._id ===
							this.order.orderedArticles[promoAgIndex].article._id &&
						OrderUtils.bogoPrice(
							response.data.articleGroup,
							this.order.type,
							this.order.preorder.type
						) <
							OrderUtils.bogoPrice(
								this.order.orderedArticles[promoAgIndex],
								this.order.type,
								this.order.preorder.type
							)
					) {
						this.order.orderedArticles[promoAgIndex].isPromo = false;
						const newPromoAg = JSON.parse(
							JSON.stringify(response.data.articleGroup)
						);
						newPromoAg.isPromo = true;
						this.order.orderedArticles.push(newPromoAg);
					}
					this.order.orderedArticles[index] = response.data.articleGroup;
					this.repository.order.next(this.order);
				}
				break;
			case OrderListAction.remove:
				if (this.order.orderedArticles[index].quantity > 1) {
					this.order.orderedArticles[index].quantity -= 1;
				} else {
					await this.onAction(index, OrderListAction.delete);
					return;
				}
				break;
		}
		this.repository.order.next(this.order);
	}

	async openCheckoutModal() {
		if (!this.isValid) {
			return;
		}
		this.loading = true;
		const result = await CheckoutModalComponent.show(
			this.modalCtrl,
			this.order,
			this.tip
		);
		if (result.data === undefined) {
			this.loading = false;
			return;
		}
		
		this.order.orderAt = result.data.orderAt;
		this.order.preorder = result.data.preorder;
		this.tip = result.data.tip;
		this.repository.order.next(this.order);
		try {
			await this.repository.createOrderWithPayment(
				this.modalCtrl,
				this.translate,
				this.order,
				this.tip,
				loading => (this.loading = loading),
				this.snackbarCtrl,
				this.order.tableNumber !== 'preorder_table'
			);
			this.tip = 0;
		} catch (e) {
			console.log(JSON.parse(JSON.stringify(e)));
		}
	}

	validate() {
		if (!this.order || !this.venue) {
			this.isValid = false;
			return;
		}
		const result = OrderUtils.validateOrder(this.venue, this.order);
		this.differenceToMvo = result.movDifference;
		this.isValid = result.valid;
	}

	totalPrice(): string {
		return numberToCurrency(
			OrderUtils.orderTotalPrice(this.order, true, true, true) + this.tip,
			this.order.currency
		);
	}

	replace(index: number, article: Article, options: ArticleOption[]) {
		this.order.orderedArticles[index].quantity = 1;
		this.order.orderedArticles[index].article = article;
		this.order.orderedArticles[index].groups = options;
	}

	onPromoApplied(order: Order) {
		this.promoError = null;
		this.repository.order.next(order);
	}

	onDeletePromo(order: Order) {
		this.promoError = null;
		this.repository.order.next(order);
	}

	onPromoCodeError(error: string) {
		if (!error) {
			// error just resetting error no error happened
			return;
		}
		// Promo error
		this.snackbarCtrl.open(error, null, {duration: 2000});
		this.repository.order.next(OrderUtils.removePromo(this.order));
		this.promoError = error;
	}

	backToMenu() {
		MenuPage.navigate(this.router);
	}
	async noteArticle(index: number) {
		const modal = await this.modalCtrl.create({
			cssClass: 'short-info-modal auto-height',
			component: NoteArticleModalComponent,
			componentProps: {
				// copy article group
				articleGroup: JSON.parse(
					JSON.stringify(this.order.orderedArticles[index])
				),
				recommend: false
			},
			showBackdrop: true,
			backdropDismiss: true
		});
		await modal.present();
		const response = await modal.onDidDismiss();
		if (response?.data) {
			this.order.orderedArticles[index].note = response?.data;
		}
	}
	async reopenPaymentMethod(orderId: string) {
		console.log(this.verifiedOrder, this.venue);
		await sleep(1000);
		if (!this.venue) {
			console.log('Venue dont loaded');
			return;
		}
		try {
			this.snackbarCtrl.open(
				'Es gab ein Problem bei der Bezahlung. Bitte versuche es mit einer anderen Zahlungsmethode.',
				null,
				{
					duration: 6000
				}
			);
			const orderResponse = (await Api.getOrder(orderId)).data;
			this.repository.verifiedOrder.emit(orderResponse);

			const result = await PaymentModalComponent.show(
				this.modalCtrl,
				this.venue,
				[orderResponse],
				this.customer,
				0,
				false,
				this.order
			);
			if (result && result.result === PaymentModalResult.SUCCESS) {
				this.repository.verifiedOrder.emit(orderResponse);
				this.repository.payment.emit(result.payment);
				return;
			}
		} catch (e) {
			console.log(e);
		}
	}
	getAmountOfPointsAnonimus() {
		return Math.round(
			OrderUtils.orderTotalPrice(this.order, true, true, true) + this.tip
		);
	}
	async navigateTorLogin() {
		await this.navService.signIn();
	}
	async navigateTorSignUp() {
		await this.navService.signUp();
	}
	deleteCoupon(coupon: Coupon) {
		console.log(this.order, coupon);
		
		if (this.order.coupon.length > 0) {
			this.order.coupon = this.order.coupon.filter(
				it => it?._id !== coupon._id
			);
			this.order.orderedArticles = this.order.orderedArticles.filter(
				articleGroup => {
					if (coupon.type === 'relative_article') {
						return !(
							coupon?.value?.articles.includes(articleGroup.article._id) &&
							articleGroup.isPromo
						);
					}
					return !(
						coupon?.value?.includes(articleGroup.article._id) &&
						articleGroup.isPromo
					);
				}
			);
			this.repository.order.next(this.order);
		}
	}

	toRegistration() {
		this.navService.signUp();
	}
	toLogin() {
		this.navService.signIn();
	}
}
